<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import {
  CheckboxRoot,
  CheckboxIndicator,
  useForwardPropsEmits,
  type CheckboxRootProps,
  type CheckboxRootEmits,
} from 'reka-ui';
import { Check, Minus } from '@lucide/vue';
import { cn } from '@/lib/utils';
const props = defineProps<CheckboxRootProps & { class?: HTMLAttributes['class'] }>();
const emit = defineEmits<CheckboxRootEmits>();
const forwarded = useForwardPropsEmits(
  computed(() => {
    const { class: _class, ...rest } = props;
    return rest;
  }),
  emit
);
</script>

<template>
  <CheckboxRoot
    v-bind="forwarded"
    :class="
      cn(
        'peer size-4 shrink-0 rounded border border-input bg-card transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
        props.class
      )
    "
  >
    <CheckboxIndicator class="flex items-center justify-center"
      ><Minus v-if="modelValue === 'indeterminate'" class="size-3.5" /><Check
        v-else
        class="size-3.5"
    /></CheckboxIndicator>
  </CheckboxRoot>
</template>
